import React from 'react'

const BluePause = (props) => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect width="10" height="10" fill="#068AE2"/>
    </svg>
)

export default BluePause
